"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Select = require("../form/Select");

var _Select2 = _interopRequireDefault(_Select);

var _NumberUtil = require("../../utils/NumberUtil");

var _ReceptionPlaceModal = require("../modal/ReceptionPlaceModal");

var _ReceptionPlaceModal2 = _interopRequireDefault(_ReceptionPlaceModal);

var _PickupPlaceModal = require("../modal/PickupPlaceModal");

var _PickupPlaceModal2 = _interopRequireDefault(_PickupPlaceModal);

var _UserUtil = require("../../utils/UserUtil");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VoucherOrderSelect = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(VoucherOrderSelect, _Component);

  function VoucherOrderSelect() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, VoucherOrderSelect);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = VoucherOrderSelect.__proto__ || (0, _getPrototypeOf2.default)(VoucherOrderSelect)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      quantity: 1,
      isShowingModal: false
    }, _this.decreaseQuantity = function () {
      if (_this.state.quantity > 1) {
        _this.setState({ quantity: --_this.state.quantity });
      }
    }, _this.increaseQuantity = function () {
      _this.setState({ quantity: ++_this.state.quantity });
    }, _this.handleInsert = function (event) {
      event.preventDefault();
      var quantity = _this.state.quantity;

      var selectedPlace = _this.getSelectedPlace();
      if (selectedPlace) {
        _this.props.handleInsertion((0, _extends3.default)({}, selectedPlace, {
          quantity: quantity
        }));
      }
      _this.setState({ quantity: 1 });
    }, _this.openModal = function (event) {
      event.preventDefault();
      _this.setModalOpenState(true);
    }, _this.closeModal = function () {
      _this.setModalOpenState(false);
    }, _this.setModalOpenState = function (isShowingModal) {
      _this.setState({ isShowingModal: isShowingModal });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(VoucherOrderSelect, [{
    key: "addressId",
    value: function addressId(address) {
      return address.postal_code.trim() + "_" + address.city.trim() + "_" + address.address.trim();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var addresses = this.props.places.reduce(function (a, v) {
        var id = _this2.addressId(v);
        var dup = a.find(function (i) {
          return i.id === id;
        });
        if (dup) {
          return a;
        }
        return a.concat({
          id: id,
          name: _this2.renderVoucherAddress(v),
          address: v.address,
          city: v.city,
          postal_code: v.postal_code
        });
      }, []);

      var placesProps = {
        onChange: function onChange(event) {
          _this2.props.fieldProps.onChange("");
          _this2.setState({ place_id: event.target.value });
        }
      };

      var places = this.props.places;

      var address = this.state.place_id ? addresses.find(function (v) {
        return v.id === _this2.state.place_id;
      }) : null;

      return _react2.default.createElement(
        "div",
        { className: "voucher-order-select" },
        _react2.default.createElement(_Select2.default, {
          disableLabel: true,
          placeholder: "Valitse paikka",
          options: addresses,
          fieldProps: placesProps
        }),
        address ? _react2.default.createElement(_Select2.default, {
          disableLabel: true,
          placeholder: "Valitse tuote",
          options: places.filter(function (place) {
            return address.id === _this2.addressId(place);
          }),
          fieldProps: this.props.fieldProps
        }) : null,
        this.renderInfo()
      );
    }
  }, {
    key: "renderInfo",
    value: function renderInfo() {
      var selectedPlace = this.getSelectedPlace();

      if (this.props.fieldProps.value === "") {
        return null;
      }

      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "div",
          { className: "voucher-info" },
          "HINTA/LIPUKE",
          " ",
          _react2.default.createElement(
            "span",
            { className: "voucher-info-text price-js" },
            this.renderVoucherPrice(selectedPlace)
          ),
          _react2.default.createElement("br", null),
          "OSOITE",
          " ",
          _react2.default.createElement(
            "span",
            { className: "voucher-info-text address-js" },
            this.renderVoucherAddress(selectedPlace)
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "voucher-quantity" },
          "LIPUKKEIDEN M\xC4\xC4R\xC4",
          _react2.default.createElement(
            "div",
            { className: "voucher-quantity-selector" },
            _react2.default.createElement(
              "div",
              {
                className: "voucher-quantity-button decrease-js",
                onClick: this.decreaseQuantity
              },
              "-"
            ),
            _react2.default.createElement(
              "div",
              { className: "voucher-quantity-text" },
              this.state.quantity
            ),
            _react2.default.createElement(
              "div",
              {
                className: "voucher-quantity-button increase-js",
                onClick: this.increaseQuantity
              },
              "+"
            )
          )
        ),
        _react2.default.createElement("div", { className: "clear" }),
        _react2.default.createElement(
          "button",
          {
            className: "voucher-insert-button insert-button-js",
            onClick: this.handleInsert,
            disabled: !selectedPlace
          },
          "Lis\xE4\xE4 ostoskoriin"
        ),
        _react2.default.createElement(
          "button",
          {
            className: "voucher-info-button",
            onClick: this.openModal,
            disabled: !selectedPlace
          },
          "Tarkemmat tiedot"
        ),
        selectedPlace ? {
          reception: _react2.default.createElement(_ReceptionPlaceModal2.default, {
            isShowingModal: this.state.isShowingModal,
            handleClose: this.closeModal,
            place: selectedPlace
          }),
          pickup: _react2.default.createElement(_PickupPlaceModal2.default, {
            isShowingModal: this.state.isShowingModal,
            handleClose: this.closeModal,
            place: selectedPlace
          })
        }[this.props.orderType] : null
      );
    }
  }, {
    key: "renderVoucherPrice",
    value: function renderVoucherPrice(place) {
      return place && (0, _NumberUtil.formatPrice)(place.price) + " (sis alv 25.5%)";
    }
  }, {
    key: "renderVoucherAddress",
    value: function renderVoucherAddress(place) {
      return place && (0, _UserUtil.formatAddress)(place.address, place.postal_code, place.city);
    }
  }, {
    key: "getSelectedPlace",
    value: function getSelectedPlace() {
      var _props = this.props,
          value = _props.fieldProps.value,
          places = _props.places;

      return places.find(function (place) {
        return place.id === parseInt(value, 10);
      });
    }
  }]);
  return VoucherOrderSelect;
}(_react.Component), _class.propTypes = {
  places: _react.PropTypes.array.isRequired,
  fieldProps: _react.PropTypes.object.isRequired,
  handleInsertion: _react.PropTypes.func.isRequired,
  orderType: _react.PropTypes.string.isRequired
}, _temp2);
exports.default = VoucherOrderSelect;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/vouchers/VoucherOrderSelect.js
 ** module id = 1201
 ** module chunks = 0
 **/